enum ComponentsEnum {
  THANK_YOU_START = 1,
  HOUSE_HOLD = 2,
  COMMERCIAL_SIZE = 3,
  POST_CODE = 4,
  PAYMENT_TYPE = 5,
  PERIOD = 6,
  RENTAL = 7,
  LAND_LORD = 8,
  LEGAL = 9,
  PRELIMINARY_RESULT = 10,
  PACKAGE = 11,
  REGISTER = 12,
  PAYMENT = 13,
  COMMENTS = 14,
  STATEMENT = 15,
  CONTRACT = 16,
  THANK_YOU = 17,
  ASK = 18,
  EXPERT_CHECK = 19,
  TEST_RESULT = 20,
}

export default ComponentsEnum;
